var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"9","viewBox":"0 0 13 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 3.91667L5.63158 8L12 1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }